import { Slider } from "@components/atoms/Slider"
import { FilmTile } from "@components/film/FilmTile"
import { Button } from "@components/ui/Button"
import { isPastEvent } from "@utils/past-event"
import { slugify } from "@utils/slugify"
import { tv } from "@utils/tw"
import { defineBlock, EditableText, useInlineEditableValue } from "eddev/blocks"
import { useHydrating } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Most Popular Films",
  description: "The most popular films of the last 2 days",
  category: "media",
  tags: ["#subpage", "#homepage", "#featured"],
  icon: "editor-video",
  keywords: ["film grid slider"],
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("content/top-films", (props) => {
  const hydrating = useHydrating()
  let tiles = props.topFilms

  // Strip out past events
  if (!hydrating) {
    tiles = props.topFilms?.filter((item) => !isPastEvent({ film: item! })) ?? []
  }

  // Limit to 10 items
  tiles = tiles?.slice(0, 10) ?? []

  const styles = createStyles({
    perRow: tiles?.length === 3 ? 3 : tiles?.length === 4 ? 4 : "auto",
  })
  const [heading] = useInlineEditableValue<string>("heading")

  if (!tiles.length) return null

  return (
    <div className={styles.wrapper()} data-mixpanel-block="Most Popular Films List" data-mixpanel-heading={heading}>
      <a id={slugify(heading)} />
      <div className="w-grid mx-auto flex justify-between items-center mb-3">
        <div className="type-title-m w-[20em] md:w-auto text-pretty flex">
          <EditableText as="h2" store="heading" defaultValue="Most Popular" className="" plainText />
        </div>
      </div>

      <Slider arrows gridInsert scrollerClass="flex gap-grid-gutter px-grid-margin-full">
        {tiles
          ?.filter((item) => !isPastEvent({ film: item! }))
          ?.map((item, i) => (
            <div key={i} className={styles.item()}>
              <FilmTile film={item!} number={i + 1} />
            </div>
          ))}
      </Slider>
    </div>
  )
})

const createStyles = tv({
  slots: {
    wrapper: "py-4",
    heading: "type-title-m text-pretty mb-3",
    item: "w-cols-8 sm:w-cols-7 flex-none py-[10px]",
  },
  variants: {
    perRow: {
      3: {
        item: "md:w-cols-4",
      },
      4: {
        item: "md:w-cols-3",
      },
      auto: {
        item: "md:w-cols-3 xl:w-cols-3",
      },
    },
  },
})
